import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { AMENITIES } from "@/data/content";

const CHAPTERS = [
  {
    n: "01",
    title: "Who we are",
    body: "Masaya Hospitality is a family-owned business based in Austin, Texas. We specialize in professionally managed furnished housing for professionals seeking comfortable, reliable, and high-quality accommodations — for a month, a semester, or a season.",
  },
  {
    n: "02",
    title: "Our mission",
    body: "Our mission is to create exceptional guest experiences while building long-term partnerships with property owners. Every home is cared for by a dedicated team that handles cleaning, maintenance, and communication directly, so guests and owners both experience consistent, dependable quality.",
  },
  {
    n: "03",
    title: "Built for longer stays",
    body: "Our spaces are designed for people staying a month or more. That means full kitchens, in-home laundry, high-speed Wi-Fi, utilities included, dedicated workspaces, and smart-lock check-in — the practical details that make an extended stay feel effortless.",
  },
];

export default function About() {
  return (
    <div data-testid="about-page" className="pt-36 md:pt-40">
      <section className="px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <Reveal className="max-w-4xl">
            <span className="text-xs sm:text-sm tracking-[0.2em] uppercase font-medium text-[#8A9A86]">About Masaya</span>
            <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light leading-[1.02] text-[#1C1917]">
              Professionally managed homes, made to feel like your own.
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="px-6 md:px-12 mt-24 md:mt-32">
        <div className="max-w-7xl mx-auto divide-y divide-[#E7E5E4] border-t border-[#E7E5E4]">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.06}>
              <div className="grid grid-cols-1 lg:grid-cols-[0.5fr_1.5fr] gap-8 lg:gap-24 py-14" data-testid={`about-chapter-${c.n}`}>
                <div className="flex items-start gap-5">
                  <span className="text-sm text-[#8A9A86] font-medium pt-1">{c.n}</span>
                  <h2 className="text-2xl sm:text-3xl font-light tracking-tight text-[#1C1917]">{c.title}</h2>
                </div>
                <p className="text-lg text-[#44403C] leading-relaxed font-light max-w-3xl">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="px-6 md:px-12 py-24 md:py-32 mt-16 bg-[#F5F5F4] border-y border-[#E7E5E4]">
        <div className="max-w-7xl mx-auto">
          <Reveal className="mb-12">
            <h2 className="text-3xl sm:text-4xl tracking-tight font-light text-[#1C1917]">What every Masaya home includes</h2>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-1">
            {AMENITIES.map((a) => (
              <div key={a.label} className="flex items-center gap-3 py-4 border-b border-[#E7E5E4]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#8A9A86]" />
                <span className="text-[#1C1917] font-light">{a.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="px-6 md:px-12 py-24 md:py-32">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <h2 className="text-3xl sm:text-4xl tracking-tight font-light text-[#1C1917] max-w-xl">Ready to find your Austin home?</h2>
          <div className="flex gap-4">
            <Link data-testid="about-properties-cta" to="/properties" className="rounded-full bg-[#1C1917] text-white px-8 py-3.5 hover:bg-[#44403C] transition-colors duration-300 font-medium text-sm">View Properties</Link>
            <Link data-testid="about-contact-cta" to="/contact" className="rounded-full border border-[#E7E5E4] text-[#1C1917] px-8 py-3.5 hover:bg-[#F5F5F4] transition-colors duration-300 font-medium text-sm">Contact</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
